// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[8].oneOf[6].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[8].oneOf[6].use[2]!../../../../node_modules/ui-connect/styles/colors.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BadgeTags_badgeTags__1Zg9e .BadgeTags_badgeTag__oNRwk:not(:first-child) {
    margin-left: 4px;
}

.BadgeTags_badgeTag__oNRwk {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["darkui_surface_1"]};
    background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["lightui_accent_1"]};
    padding: 4px 8px;
    border-radius: 4px;
    text-transform: uppercase;
    font-size: 11px;
}
`, "",{"version":3,"sources":["webpack://./src/components/badges/components/BadgeTags.module.css"],"names":[],"mappings":"AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mDAAuB;IACvB,8DAAkC;IAClC,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;AACnB","sourcesContent":["@value (darkui_surface_1, lightui_accent_1) from 'ui-connect/styles/colors.module.css';\n\n.badgeTags .badgeTag:not(:first-child) {\n    margin-left: 4px;\n}\n\n.badgeTag {\n    color: darkui_surface_1;\n    background-color: lightui_accent_1;\n    padding: 4px 8px;\n    border-radius: 4px;\n    text-transform: uppercase;\n    font-size: 11px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"darkui_surface_1": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["darkui_surface_1"]}`,
	"lightui_accent_1": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["lightui_accent_1"]}`,
	"badgeTags": `BadgeTags_badgeTags__1Zg9e`,
	"badgeTag": `BadgeTags_badgeTag__oNRwk`
};
export default ___CSS_LOADER_EXPORT___;
